const STICKY_VERIFY_COOKIE_NAME = 'stickyVerifyCustomer';
const CUSTOMER_VERIFIED_COOKIE_NAME = 'customerVerified';

const COOKIE_MAX_AGE = 300; // 5 minutes

/**
 * Helper to get a cookie value by name
 */
const getCookieValue = (cookieName: string): string | null => {
  const cookies = document.cookie.split(';');
  const cookie = cookies.find((c) => c.trim().startsWith(`${cookieName}=`));
  if (cookie) {
    // Get everything after the first '=' to handle values that might contain '='
    const value = cookie.substring(cookie.indexOf('=') + 1).trim();
    return value === 'false' ? null : value;
  }
  return null;
};

/**
 * Helper to set a cookie value
 */
const setCookieValue = (cookieName: string, value: string | null, maxAge: number = COOKIE_MAX_AGE): void => {
  if (value === null) {
    document.cookie = `${cookieName}=false; path=/; max-age=0`;
  } else {
    document.cookie = `${cookieName}=${value}; path=/; max-age=${maxAge}`;
  }
};

/**
 * Get the sticky verify customer ID from cookie
 */
export const getStickyVerifyCustomerId = (): string | null => {
  return getCookieValue(STICKY_VERIFY_COOKIE_NAME);
};

/**
 * Set the sticky verify customer ID cookie
 */
export const setStickyVerifyCustomerId = (customerId: string | null): void => {
  setCookieValue(STICKY_VERIFY_COOKIE_NAME, customerId);
};

/**
 * Get the verified customer ID from cookie
 */
export const getVerifiedCustomerId = (): string | null => {
  return getCookieValue(CUSTOMER_VERIFIED_COOKIE_NAME);
};

/**
 * Set the verified customer ID cookie
 */
export const setVerifiedCustomerId = (customerId: string | null): void => {
  setCookieValue(CUSTOMER_VERIFIED_COOKIE_NAME, customerId);
};

/**
 * Check if a customer ID matches the verified customer cookie
 */
export const isCustomerVerified = (customerId: string | null | undefined): boolean => {
  if (!customerId) {
    return false;
  }
  const verifiedCookieValue = getVerifiedCustomerId();
  return verifiedCookieValue !== null && String(verifiedCookieValue) === String(customerId);
};

/**
 * Clear all verification-related cookies
 */
export const clearVerificationCookies = (): void => {
  setStickyVerifyCustomerId(null);
  setVerifiedCustomerId(null);
};
